import './styles.scss'
import * as React from 'react'
import { Modal, UncontrolledTooltip } from 'reactstrap'

import { Button } from 'components/Form'
import { I18n } from 'react-redux-i18n'
import Chips from 'react-chips'
import { getStaticImage } from 'utils/statics'

const ProcessesDetail = (props) => {
  const { toggle, save, valuesToEdit, isSubmitting } = props
  const [process, setProcess] = React.useState({ label: '', processId: '', processVars: [] })
  const [messageError, setMessageError] = React.useState(null)
  React.useEffect(()=> {
    if (valuesToEdit._id) {
      setProcess(valuesToEdit)
      // nauta.get(valuesToEdit._id).then(result => {
      // if (result.data.length > 0)
      //   setProcess(result.data[0])
      // }).catch(error => {
      //   console.error(error)
      // })
    }
  }, [valuesToEdit])

  React.useEffect(()=>{
    setMessageError(null)
  }, [process])

  const onClick = () => {
    if (!process || !process.label || process.label.length < 0) {
      setMessageError(I18n.t('processes_error_required_name'))
      return
    }
    if (!process || !process.processId || process.processId.length < 0) {
      setMessageError(I18n.t('processes_error_required_param'))
      return
    }
    save(process)
  }

  return (
    <div className='processes-detail'>
      <Modal centered isOpen={props.isOpen} toggle={props.toggle} className={''} contentClassName={'modal-content-processes'}>
        <div className='modal-wrapper-header'>
          <h1>{process._id ? I18n.t('dashboard_edit-process') : I18n.t('dashboard_addProcess')}</h1>
          <span onClick={props.toggle}>
            <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close'/>
          </span>
        </div>
        <legend dangerouslySetInnerHTML={{ __html:process._id ? I18n.t('processes_edit_process_legend') : I18n.t('processes_add_process_legend') }}/>

        <label htmlFor='process'>{I18n.t('dashboard_name')}</label>
        <input id={'input-modal'} name='label' type='text' defaultValue={process.label} onChange={(value) => setProcess({ ...process, label: value.target.value })} />
        <label htmlFor='process'>{I18n.t('processes_input_param')}</label>
        <input id={'input-modal'} name='processId' type='text' value={process.processId}  onChange={(value) => setProcess({ ...process, processId: value.target.value.replace(/ +/g, "") })} />
        <label htmlFor='process'>
          {I18n.t('processes_input_processVars')}
          <i id={'processVars'} className='fa fa-info-circle' />
        </label>
        <UncontrolledTooltip placement='top' target='processVars'>
          {I18n.t('processes_input_processVars_tooltip')}
        </UncontrolledTooltip>
        <Chips
          value={process.processVars}
          onChange={(value) => setProcess({ ...process, processVars: value })}
          chipTheme={{ chip: { background: '#F2F2F2', color: '#E87721' } }}
        />
        <small className='error'>{messageError}</small>
        <div className='wrapper-buttons'>
          <Button
            secondary={true}
            value={I18n.t('dashboard_save')}
            onClick={onClick}
            isSubmitting={isSubmitting}
          />
          <Button
            value={I18n.t('dashboard_cancel')}
            onClick={toggle}
          />
        </div>

      </Modal>
    </div>
  )
}

export default ProcessesDetail